<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-2xl text-gray-800 dark:text-gray-200 leading-tight">
                Edit page
            </h2>
        </template>
        <page-editor :client="client"
                     :project="project"
                     :page-statuses="pageStatuses"
                     :page="page"
                     :page-types="pageTypes"
        ></page-editor>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import PageEditor from "@/Pages/Admin/Page/Partials/PageEditor";

export default {
    components: {
        PageEditor,
        AppLayout,
    },
    props: {
        client: {
            type: Object,
            required: true,
        },
        project: {
            type: Object,
            required: true,
        },
        pageStatuses: {
            type: Array,
            required: true,
        },
        page: {
            type: Object,
            required: true,
        },
        pageTypes: {
            type: Object,
            required: true,
        }
    },
}
</script>
